import React from "react";
import {useTranslation} from "react-i18next";

interface Props {
    className?: string;
}

export const UsersPlaceholder: React.FC<Props> = ({ className }: Props) => {
    const {t} = useTranslation();
    return (
        <div className={`d-flex justify-content-center align-items-center p-4 flex-grow-1 placeholder-text ${className}`}>{t("users_not_found")}</div>
    );
};

export default UsersPlaceholder;